import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  AddressRequest,
  AddressResponse,
  HealthMetricsResponse,
  SubscriptionDetailResponse,
  UserDetailResponseActivityLevelEnum,
  UserDetailResponseDietGoalEnum,
  UserDetailResponseDietTypeEnum,
  UserResponse,
  UserResponseGenderEnum,
} from "../openapi/client";

export interface IUser {
  phoneNumber?: string;
  fullName?: string;
  gender?: UserResponseGenderEnum;
  birthDate?: string;
  height?: number;
  weight?: number;
  targetWeight?: number;
  allergens?: Array<string>;
  medicalConditions?: Array<string>;
  dislikes?: Array<string>;
  address?: AddressRequest;
  roles?: Set<string>;
  activeSubscription?: SubscriptionDetailResponse;
  deliveryNote?: string;
  dietGoal?: UserDetailResponseDietGoalEnum;
  activityLevel?: UserDetailResponseActivityLevelEnum;
  dietType?: UserDetailResponseDietTypeEnum;
  healthMetrics?: HealthMetricsResponse;
  walletActualBalance?: number;
}

const initialState: IUser = {};

export const userDetailSlice = createSlice({
  name: "userDetail",
  initialState,
  reducers: {
    setUserDetail: (state, action: PayloadAction<any>) => {
      return {
        ...action.payload,
      };
    },
    resetUserDetail: (state) => {
      return {};
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserDetail, resetUserDetail } = userDetailSlice.actions;

export default userDetailSlice.reducer;
